import { IPdpData } from '../templates/product/types/PDP';
import { uniq } from 'lodash-es';

// ? [REVISIT] product type? this is complicated for the function name?
export const itemIsAccessory = (pdpData: IPdpData) => {
  const { products } = pdpData;
  const variants = products[0]?.variants;
  const options = pdpData.products[0]?.options;
  if (!variants || !options) return false;
  let nonColorOption = Object.keys(options).find((opt) => opt !== 'Color') + '';
  //@ts-expect-error // ? [REVISIT]
  let optionValues = options[nonColorOption];
  //@ts-expect-error // ? [REVISIT]
  let nonColorOptionValues = uniq(optionValues.map((value) => value.toLowerCase().replace(' ', '')));
  return nonColorOptionValues.length < 2 || variants.length < 2 || Object.entries(options).length < 2;
};
